import { Component, Injectable, Inject, PLATFORM_ID, OnInit, OnDestroy } from '@angular/core';
import { NgIf, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { ShiftClosureService } from '../../../core/services/shift-closure.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SearchModalComponent } from '../search-modal/search-modal.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  standalone: true,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [NgIf, RouterModule, MatDialogModule],
})
export class HeaderComponent implements OnInit, OnDestroy {
  currentUser: any;
  currentDay: string = '';
  currentMonth: string = '';
  currentYear: string = '';
  private userSubscription?: Subscription;



  constructor(private authService: AuthService, private shiftClosureService: ShiftClosureService, private snackBar: MatSnackBar, private dialog: MatDialog, @Inject(PLATFORM_ID) private platformId: Object) {
    // Inicializar currentUser desde localStorage si está disponible
    if (isPlatformBrowser(this.platformId)) {
      const userData = localStorage.getItem('currentUser');
      if (userData) {
        this.currentUser = JSON.parse(userData);
      }
    }
  }

  ngOnInit(): void {
    this.updateDate();
    
    // Escuchar cambios en localStorage para currentUser
    if (isPlatformBrowser(this.platformId)) {
      // Verificar periódicamente si currentUser ha cambiado
      this.userSubscription = setInterval(() => {
        const userData = localStorage.getItem('currentUser');
        if (userData) {
          const newUser = JSON.parse(userData);
          if (JSON.stringify(this.currentUser) !== JSON.stringify(newUser)) {
            this.currentUser = newUser;
            console.log('[Header] currentUser actualizado:', this.currentUser);
          }
        }
      }, 500) as any; // Verificar cada 500ms
    }
  }
  
  ngOnDestroy(): void {
    if (this.userSubscription) {
      clearInterval(this.userSubscription as any);
    }
  }
  

  updateDate(): void {
    const now = new Date();
    this.currentDay = now.getDate().toString().padStart(2, '0');
    this.currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');
    this.currentYear = now.getFullYear().toString();
  }
  

  isMobileMenuExpanded = false;
  isMobileMantenedoresExpanded = false;
  isMobileChartsExpanded = false;
  isMobileContainerExpanded = false;

  toggleMobileMenu() {
    this.isMobileMenuExpanded = !this.isMobileMenuExpanded;
  }
  toggleMobileMantenedores() {
    this.isMobileMantenedoresExpanded = !this.isMobileMantenedoresExpanded;
  }
  toggleMobileCharts() {
    this.isMobileChartsExpanded = !this.isMobileChartsExpanded;
  }
  toggleMobileContainer() {
    this.isMobileContainerExpanded = !this.isMobileContainerExpanded;
  }

  hasRole(role: string): boolean {
    return this.authService.hasRole(role);
  }

  /**
   * Obtiene el texto del rol del usuario para mostrar en el header
   * Retorna "Jefe de Turno" si tiene rol 'novedades', caso contrario "Operador"
   */
  get userRoleText(): string {
    return this.authService.hasRole('novedades') ? 'Jefe de Turno' : 'Operador';
  }

  /**
   * Verifica si el usuario puede acceder a una funcionalidad específica
   */
  canAccess(feature: string): boolean {
    return this.authService.canAccess(feature);
  }

  openSearchModal(): void {
    const dialogRef = this.dialog.open(SearchModalComponent, {
      width: '90vw',
      maxWidth: '1000px',
      height: '80vh',
      disableClose: false,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      // Handle any result if needed
      console.log('Search modal was closed');
    });
  }
}
